import Vue from "vue";
export default Vue.extend({
    name: "Icon",
    props: {
        name: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            default: 16,
        },
        height: {
            type: Number,
            default: 16,
        },
        size: {
            type: Number,
            default: undefined,
        },
        fill: {
            type: String,
            default: "none",
        },
    },
    computed: {
        iconComponent() {
            if (this.name) {
                return () => import(
                /* webpackChunkName: "icons/[request]" */
                /* webpackPrefetch: true */
                `./icons/${this.name}.svg`);
            }
        },
    },
});
